import './Home.css'
import Hero from '../../Hero/Hero';
import HowItWorks from '../../HowItWorks/HowItWorks';
import ValuationApproach from '../../ValuationApproach/ValuationApproach';
import Pricing from '../Pricing/Pricing';
import WhyClybourne from '../../WhyClybourne/WhyClybourne';
import AboutUs from '../../AboutUs/AboutUs';
import KnowledgeHub from '../../KnowledgeHub/KnowledgeHub';
import Testimonials from '../../Testimonials/Testimonials';
import ValuationToolkit from '../../ValuationToolkit/ValuationToolkit';
import ContactAndFooter from '../../ContactAndFooter/ContactAndFooter';
// import Footer from '../../Footer/Footer';
// import Demo from '../../Demo/Demo';
function Home() {
    return (
        <>
            <Hero />
            <HowItWorks />
            <ValuationApproach />
            <Pricing />
            <WhyClybourne />
            <AboutUs />
            <KnowledgeHub />
            <Testimonials />
            <ValuationToolkit />
            <ContactAndFooter />
        </>
    );
}

export default Home;
